import { render, staticRenderFns } from "./GeneralSummary.vue?vue&type=template&id=6585604b"
import script from "./GeneralSummary.vue?vue&type=script&lang=js"
export * from "./GeneralSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports